<div class="arrow-combo"
    (click)="onClickArrow()"
     [title]="title | translate">
    <span class="dropdown-arrow">
        <i class="fas"
           [ngClass]="caretDown ? 'fa-caret-down': 'fa-caret-up'"
           aria-hidden="true">
        </i>
    </span>
</div>
